module.exports = __webpack_public_path__ + "img/logo.76289a1f.svg";